export default __webpack_public_path__ + "static/media/logo.41d5072a.png";